export const environment = {
    production: true,
    apiUrl: 'https://consmin.juvenalorden.se',
};



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/environments/environment.ts